'use client';

import Image from 'next/image';
import Link from 'next/link';
import { useParams } from 'next/navigation';
import classes from './VerticalCard.module.scss';
import { Badge, Button, Card, Group, Space, Text } from '@mantine/core';
import { useDictionary } from '@/src/dictionaries/dictionary-provider';
import { useAOS } from '@/src/lib/hooks/useAOS';
import { Article, Product } from '@/src/types/Header';

export function VerticalCard({ article, product }: { article?: Article; product?: Product }) {
  const dictionary = useDictionary();
  const cardData = article ? article : product;
  const date = new Date(article ? (cardData as Article)?.createdAt : '');
  const params = useParams();
  const lang = params.lang ?? 'fr';
  useAOS();

  const formattedDate = article
    ? new Intl.DateTimeFormat(lang === 'en' ? 'en-GB' : 'fr-FR', {
      day: '2-digit', // Two-digit day
      month: 'long', // Full month name
      year: 'numeric', // Full year
    }).format(date)
    : '';

  const link = article
    ? `/articles/${encodeURIComponent(article?.title?.replaceAll(' ', '-'))}`
    : // @ts-ignore
    `/products/${product?.title[lang] ? product?.title[lang]?.replaceAll(' ', '-') : product?.title?.replaceAll(' ', '-')}`;

  return (
    <Card withBorder className={classes.card} data-aos="fade-up">
      <Card.Section className={classes.imageSection}>
        {article && (
          <Badge color="grey" className={classes.date}>
            {formattedDate}
          </Badge>
        )}

        <Image
          src={cardData?.mainImage ?? ''}
          // @ts-ignore
          alt={cardData?.title[lang] ?? cardData?.title}
          fill
          sizes="cover"
          style={{ objectFit: 'cover' }}
        />
      </Card.Section>

      <Group justify="space-between" mt="md" w="100%">
        <div className={classes.title}>
          <Text fw={500} className={classes.title}>
            {/* @ts-ignore */}
            {cardData?.title[lang] ?? cardData?.title}
          </Text>
          <Text fz="xs" c="dimmed">
            {/* @ts-ignore */}
            {article ? dictionary.articles.label : dictionary.products.label}
          </Text>
        </div>
      </Group>

      <Card.Section className={classes.section} mt="md">
        <Text fz="sm" c="dimmed" className={classes.label}>
          {/* @ts-ignore */}
          {cardData?.description[lang] ?? cardData?.description}
        </Text>
      </Card.Section>

      <Space h="lg" />
      <Space h="lg" />
      <Space h="lg" />

      <Card.Section className={`${classes.section} ${classes.bottomCard}`}>
        <Group gap={30}>
          {/* @ts-ignore */}
          {product && cardData?.price && (
            <div>
              {<Text fz="xl" fw={700} style={{ lineHeight: 1 }}>
                {/* @ts-ignore */}
                {cardData?.price} €
              </Text>}
              {/* <Text fz="sm" c="dimmed" fw={500} style={{ lineHeight: 1 }} mt={3}>
                Prix sur demande
              </Text> */}
            </div>
          )}

          <Link href={link} className={!product ? classes.link : ''}>
            <Button className={classes.button} fullWidth={!product} style={{ flex: 1 }}>
              {article ? dictionary.articles.readMore : dictionary.products.readMore}
            </Button>
          </Link>
        </Group>
      </Card.Section>
    </Card>
  );
}
